var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisconnected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "96pt",
    height: "96pt",
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m34.922 54c-2.2031 2.4531-5.375 4-8.9219 4h-6c-6.6172 0-12-5.3828-12-12 0-6.6172 5.3828-12 12-12h6c3.5469 0 6.7188 1.5469 8.9219 4h9.3984c-3.0938-7.0547-10.133-12-18.32-12h-6c-11.031 0-20 8.9688-20 20s8.9688 20 20 20h6c8.1875 0 15.227-4.9453 18.32-12z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76 26h-6c-8.1875 0-15.227 4.9453-18.312 12h9.3906c2.2031-2.4531 5.3828-4 8.9219-4h6c6.6172 0 12 5.3828 12 12 0 6.6172-5.3828 12-12 12h-6c-3.5391 0-6.7188-1.5469-8.9219-4h-9.3906c3.0859 7.0547 10.125 12 18.312 12h6c11.031 0 20-8.9688 20-20s-8.9688-20-20-20",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.945 8l-6.9453 3.9688 12.109 16.211 2.6484-1.5156z",
    fill: "#00BCD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.055 8l6.9453 3.9688-12.109 16.211-2.6484-1.5156z",
    fill: "#00BCD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.055 88l6.9453-3.9688-12.109-16.211-2.6484 1.5156z",
    fill: "#00BCD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.945 88l-6.9453-3.9688 12.109-16.211 2.6484 1.5156z",
    fill: "#00BCD4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnected);
export default __webpack_public_path__ + "static/media/disconnected.f1c6a839ddda1c75a4ff1cc3f1a6c66a.svg";
export { ForwardRef as ReactComponent };